import { Link } from 'react-router-dom';

export default function ServiceSection() {
  const services = [
    {
      title: '身体介護',
      description: '食事・入浴・排泄などの身体的なケアを、ご利用者様の状態に合わせて丁寧に提供します。',
      icon: 'ri-hand-heart-line'
    },
    {
      title: '生活援助',
      description: '掃除・洗濯・買い物・調理など、日常生活に必要な家事をサポートし、快適な暮らしをお手伝いします。',
      icon: 'ri-home-heart-line'
    }
  ];

  return (
    <section className="py-24 bg-white observe-animation opacity-0">
      <div className="container mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div className="space-y-8">
            <div>
              <span className="text-cyan-500 text-sm font-semibold tracking-wider uppercase">Service</span>
            </div>
            
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900">
              提供サービス
            </h2>

            <div className="space-y-6">
              {services.map((service, index) => (
                <div
                  key={index}
                  className="bg-white border-l-4 border-cyan-500 rounded-2xl p-8 shadow-sm hover:shadow-md transition-all duration-300"
                >
                  <div className="flex items-start gap-4">
                    <div className="w-12 h-12 bg-cyan-100 rounded-full flex items-center justify-center flex-shrink-0">
                      <i className={`${service.icon} text-2xl text-cyan-600`}></i>
                    </div>
                    <div>
                      <h3 className="text-xl font-bold text-gray-900 mb-2">
                        {service.title}
                      </h3>
                      <p className="text-gray-700 leading-relaxed">
                        {service.description}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <Link
              to="/service"
              className="inline-flex items-center gap-2 px-8 py-4 bg-cyan-500 text-white rounded-full font-medium hover:bg-cyan-600 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
            >
              サービス詳細を見る
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>

          <div className="relative h-[600px] rounded-3xl overflow-hidden shadow-xl">
            <img
              src="https://public.readdy.ai/ai/img_res/2bbdd056fd1e3b83a63c87e8e1bec41f.jpg"
              alt="介護サービスの様子"
              className="w-full h-full object-cover object-top"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
